import { request } from '@/common';
import { HelperCore } from '@/common/dependencies';
import { makeAutoObservable, runInAction } from 'mobx';

class Store {
  listData = [];
  pages = 1;

  constructor() {
    makeAutoObservable(this);
  }

  getAigentList() {
    request
      .get('/ai_agent/recent', {
        params: {
          limit: 20,
          recommend: 1,
        },
      }).then(res => {
        const list = res.data?.list || [];
        runInAction(() => {
          this.listData = list;
        });
      })
  }

  setPages = page => {
    this.pages = page;
  };

  getTotal = () => {
    return 3 + (this.pages - 1) * 5
  }

  reset() {
    this.pages = 1
    this.listData = []
  }
}

const modelHistoryStore = new Store();
export default modelHistoryStore;
